<script setup lang="ts">

import {ref, computed, onMounted, watch} from 'vue'
import {CharacterInfoGameService} from "@/services/characterInfoService.js"
import {fallbackOnError} from "@/utils/imageFallback"
import {avatarPlaceholderUrl} from "@/utils/avatarPlaceholder"
import FlowSignMark from '@/components/CharacterToken/FlowSignMark.vue'

const props = defineProps<{
  charId: string;
  gmMode: boolean;
}>()

/* Only an id reaches this component, never a biography, so the placeholder is
   `other.png` — the default the server's own avatar field carries. */
const avatarPlaceholder = avatarPlaceholderUrl()
const avatarUrl = ref<string>(avatarPlaceholder);
const signed = ref(false);
const loading = ref(true);
const fetchAvatar = async () => {
  loading.value = true;
  const presentation = await CharacterInfoGameService.getAvatarPresentation(props.charId, props.gmMode);
  avatarUrl.value = presentation.url || avatarPlaceholder;
  signed.value = presentation.signed;
  loading.value = false;
};
onMounted(fetchAvatar);
watch(() => props.charId, fetchAvatar);
watch(() => props.gmMode, fetchAvatar);

</script>

<template>
  <span class="char-avatar-wrap">
    <img
        :src="avatarUrl"
        alt="Character Avatar"
        class="char-avatar-img"
        @error="fallbackOnError($event, avatarPlaceholder)"
    />
    <FlowSignMark v-if="signed" :size="14"/>
  </span>
</template>

<style scoped>
.char-avatar-wrap {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
  line-height: 0;
}

.char-avatar-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
}
</style>